module.exports = __webpack_public_path__ + "img/qr_ds_logo.375e83fb.png";